<!-- @名称：header.vue
@author: tengjd
@功能：1、重构导航
@时间：2023/3/29 -->
<style rel="stylesheet/scss" lang="scss">
.nav-box-all{
  width: 1200px;
  margin: 0 auto;
}
.navbar.navbar {
  width: 844px;
  height: 64px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  font-size: 16px;
  line-height: 64px;
  text-align: center;
  img{
    position: relative;
    top: 8px;
    width: 46px;
    height: 30px;
  }
}
.navbar-logotext {
  margin-left: 10px;
  font-weight: 600;
  cursor: pointer;
  color: #196CFC;
}

.navbar .navbar-right {
  display: inline-block;
  min-width: 500px;
  display: flex;
  justify-content: space-evenly;
  li .active {
  color: #196CFC;
  font-weight: 600;
}
  a {
    display: block;
    color: #606060;

    &:hover {
      color: #196CFC;
    }
  }
}
</style>
<template>
  <div class="nav-box-all">
    <nav class="navbar navbar-fixed-top">
      <div class="navbar-left">
        <img src="../../static/icon.svg" alt="广东盈信保险经纪有限公司">  
        <a class="navbar-logotext" href="/">盈信保险经纪</a>
      </div>
      <ul class="navbar-right">
        <li v-for="(items, index) in headerData" :key="index">
          <a v-if="items.router" :href="items.router" :target="items.target">
            <span :class="selectindex == index ? 'spanborder active' : 'spanborder'">{{ items.title }}</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
export default {
  props: {
    selectindex: {
      type: Number
    }
  },
  data() {
    return {
      headerData: [{
        'title': '首页',
        router: '/',
        titleList: []
      },
      {
        'title': '保险产品',
        router: '/product',
        titleList: []
      },
      {
        'title': '信息披露',
        router: '/infomation',
        titleList: []
      },
      {
        'title': '公司新闻',
        router: '/news',
        titleList: []
      },
      {
        'title': '联系我们',
        router: '/linkus',
        titleList: []
      }]
    }
  },
  created() {
    // console.log(this.selectindex)
  },
  methods: {

  }
}
</script>


// WEBPACK FOOTER //
// src/components/headercontent.vue